import React from "react"
import { Input } from "antd"

import DataQButton from "shared/ui/Buttons/DataQButton.component"
import { DatamapValue } from "types/datamap.types"

interface DatamapValuesEditorProps {
  values: DatamapValue[]
  onChange: (values: DatamapValue[]) => void
}

/** The code,label pairs of one row, edited in place. */
const DatamapValuesEditor: React.FC<DatamapValuesEditorProps> = ({ values, onChange }) => {
  const set = (index: number, patch: Partial<DatamapValue>): void =>
    onChange(values.map((value, i) => (i === index ? { ...value, ...patch } : value)))

  return (
    <div className="flex w-96 flex-col gap-1">
      {values.map((value, index) => (
        <div key={index} className="flex items-center gap-1">
          <Input size="small" className="w-20" aria-label="Code" value={value.code} onChange={(e) => set(index, { code: e.target.value })} />
          <Input size="small" aria-label="Answer label" value={value.label} onChange={(e) => set(index, { label: e.target.value })} />
          <DataQButton
            size="small"
            type="danger"
            aria-label={`Remove code ${value.code}`}
            onClick={() => onChange(values.filter((_, i) => i !== index))}
          >
            Remove
          </DataQButton>
        </div>
      ))}
      <DataQButton size="small" type="secondary" className="self-start" onClick={() => onChange([...values, { code: "", label: "" }])}>
        Add code
      </DataQButton>
    </div>
  )
}

export default DatamapValuesEditor
